import {Component, OnInit} from '@angular/core';
import {AnnouncementModel} from '../../models/announcement-model';
import {ModalDialogV3} from '../../../../shared-modal-dynamic/models/modal-dialog-v3';

@Component({
    selector: 'app-announcement.modal',
    templateUrl: './announcement.modal.component.html',
    styleUrls: ['./announcement.modal.component.scss']
})
export class AnnouncementModalComponent extends ModalDialogV3 implements OnInit {
    public  model: AnnouncementModel;


    constructor(
    ) {
        super();
    }

    ngOnInit(): void {

        // load model via this.modalParams.model
        this.model = this.modalParams.model as AnnouncementModel;

        this.model.message = this.model.message.replace(/\n/g, '<br>');
    }

    onCancelBtnClicked() {
        super.close();
    }

    onConfirmBtnClick() {
        this.announceModelChanged(this.model);
        super.close();
    }
}
